"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/web.timers.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LeftOutlined = _interopRequireDefault(require("@ant-design/icons/LeftOutlined"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _input = _interopRequireDefault(require("antd/lib/input"));

var _drawer = _interopRequireDefault(require("antd/lib/drawer"));

var _link = require("@meepshop/link");

var _AdTrack = _interopRequireDefault(require("@meepshop/context/lib/AdTrack"));

var _locales = require("@meepshop/locales");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/index.less");

var styles = {
  "header": "meepshop-meep-ui__mobileLayout-index__header",
  "barsIcon": "meepshop-meep-ui__mobileLayout-index__barsIcon",
  "logo": "meepshop-meep-ui__mobileLayout-index__logo",
  "image": "meepshop-meep-ui__mobileLayout-index__image",
  "headerMenu": "meepshop-meep-ui__mobileLayout-index__headerMenu",
  "drawer": "meepshop-meep-ui__mobileLayout-index__drawer",
  "member": "meepshop-meep-ui__mobileLayout-index__member",
  "menu": "meepshop-meep-ui__mobileLayout-index__menu",
  "search": "meepshop-meep-ui__mobileLayout-index__search",
  "searchHeader": "meepshop-meep-ui__mobileLayout-index__searchHeader",
  "searchContent": "meepshop-meep-ui__mobileLayout-index__searchContent",
  "sidebar": "meepshop-meep-ui__mobileLayout-index__sidebar",
  "showIcon": "meepshop-meep-ui__mobileLayout-index__showIcon"
};

var SearchDrawer = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var closeDrawer = _ref.closeDrawer,
      showSearchContent = _ref.showSearchContent,
      drawerStyle = _ref.drawerStyle;

  var _useTranslation = (0, _locales.useTranslation)('menu'),
      t = _useTranslation.t;

  var router = (0, _link.useRouter)();
  var adTrack = (0, _react.useContext)(_AdTrack["default"]);
  var prevValue = (0, _react.useRef)('');
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (showSearchContent && inputRef.current) {
      setTimeout(function () {
        inputRef.current.focus({
          cursor: 'end'
        });
      }, 0);
    }
  }, [inputRef, showSearchContent]);

  var handleSearch = function handleSearch(newValue) {
    closeDrawer();
    inputRef.current.blur();
    if (prevValue.current === newValue) return;
    router.push({
      pathname: '/products/',
      query: {
        search: newValue
      }
    });
    adTrack.search({
      searchString: newValue
    });
    prevValue.current = newValue;
  };

  return /*#__PURE__*/_react["default"].createElement(_drawer["default"], {
    className: "".concat(styles.drawer, " ").concat(styles.search),
    visible: showSearchContent,
    placement: "left",
    width: "100%",
    style: drawerStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.searchHeader
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "text",
    icon: /*#__PURE__*/_react["default"].createElement(_LeftOutlined["default"], {
      style: {
        fontSize: 20
      }
    }),
    onClick: closeDrawer
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.searchContent
  }, /*#__PURE__*/_react["default"].createElement(_input["default"].Search, {
    autoFocus: true,
    inputMode: "search",
    ref: inputRef,
    size: "large",
    placeholder: t('search'),
    onSearch: handleSearch,
    style: {
      width: '100%',
      height: '42px'
    }
  })));
});

var _default = SearchDrawer;
exports["default"] = _default;